import {Component, OnDestroy, OnInit} from '@angular/core';
import {ClassroomInitService} from '@app/modules/shared/services/classroom-init.service';
import {WrtcService} from '@app/modules/wrtc/services/wrtc.service';
import {WebSocketService} from '@app/modules/shared/services/web-socket.service';
import {CookieService} from '@app/modules/shared/services/cookie.service';
import {DiagnosticsService} from '@app/modules/diagnostics/services/diagnostics.service';
import {ClassroomState, ClassroomStateModel} from '@app/state/classroom-state.service';
import {Store} from '@ngxs/store';
import {Router} from '@angular/router';

@Component({
  selector: 'app-main-page',
  templateUrl: './main-page.component.html',
  styleUrls: ['./main-page.component.css']
})
export class MainPageComponent implements OnInit, OnDestroy {
  private classroom: ClassroomStateModel;

  constructor(
    public classroomInitService: ClassroomInitService,
    private wrtcService: WrtcService,
    private cookieService: CookieService,
    private diagnosticsService: DiagnosticsService,
    private webSocketService: WebSocketService,
    private router: Router,
    private store: Store
  ) {
    this.listenStoreChanges();
  }

  public ngOnInit(): void {
    if (this.classroom.roomNum === 0) {
      this.router.navigateByUrl(`/incorrect-url`).then();
    } else {
      this.cookieService.set('isInRoom', 'true');
      if (!this.diagnosticsService.passed) {
        this.router.navigateByUrl(`/${this.classroom.roomNum}/diagnostics`).then();
      } else {
        this.classroomInitService.init();
      }
    }
  }

  public ngOnDestroy(): void {
    this.wrtcService.disconnectFromRoom();
    this.webSocketService.disconnect();
  }

  private listenStoreChanges(): void {
    this.store.select(ClassroomState).subscribe((classroom: ClassroomStateModel) => {
      this.classroom = classroom;
    });
  }
}
